import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Styled from './styles';
import Image from '../../../Common/Image';
import { Icon } from '../../../Common/Page/styles';
import * as icons from '../../../../styles/icons';
import { buildTransferLinkAuto, BET } from '../../../../helpers/transfer';
import AppLink from '../../../Common/AppLink';
import { selectUkiCustomerId } from '../../../../store/modules/user/selectors';
import { selectIsLoggedIn } from '../../../../store/modules/auth/selectors';

const PartRegAd = ({ isLoggedIn, isV2Customer }) => {
    const link = buildTransferLinkAuto(
        BET,
        `?open=upgradereg`,
        isLoggedIn,
        isV2Customer,
        's6_fbnavoffer-tn91',
        '1197317355'
    );
    const termsLink = buildTransferLinkAuto(
        BET,
        '/lp/free-to-play-offer',
        isLoggedIn,
        isV2Customer,
        null
    );

    return (
        <Styled.AdContainer>
            <Styled.Details>
                <AppLink app="skybet" link={link}>
                    <div>
                        <div>
                            Get a free £20 bet{' '}
                            <Icon data-char={icons.PoundShield} />
                        </div>
                        <div>No deposit required.</div>
                    </div>
                    <div>
                        <Image
                            src="/img/products/sky-bet.png?updated=2020-10-08"
                            alt="SkyBet logo"
                            height="22px"
                        />
                    </div>
                </AppLink>
            </Styled.Details>
            <Styled.TermsAndConditions
                href={termsLink}
                target="_blank"
                rel="noopener noreferrer"
            >
                T&Cs apply.
            </Styled.TermsAndConditions>
        </Styled.AdContainer>
    );
};

PartRegAd.defaultProps = {
    isLoggedIn: false,
    isV2Customer: false
};

PartRegAd.propTypes = {
    isLoggedIn: PropTypes.bool,
    isV2Customer: PropTypes.bool
};

const mapStateToProps = state => ({
    isLoggedIn: selectIsLoggedIn(state),
    isV2Customer: !!selectUkiCustomerId(state)
});

export default connect(mapStateToProps)(PartRegAd);
